import { render } from "./px-input-password.vue?vue&type=template&id=5164516c&scoped=true&ts=true"
import script from "./px-input-password.vue?vue&type=script&lang=ts"
export * from "./px-input-password.vue?vue&type=script&lang=ts"

import "./px-input-password.vue?vue&type=style&index=0&id=5164516c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5164516c"]])

export default __exports__